define('widgets/filters',[
	'jquery',
	'lib/jquery-ui/widget'
], function ($) {

	return $.widget('muse.filters', {

		options: {
		},

		_create: function () {

			this._on({
				'click a': $.proxy(this, 'onCategoryClick'),
				'click li[data-filter]': $.proxy(this, 'onFilterClick')
			});

			this.$list = this.element.find('ul:visible');

		},

		onCategoryClick: function (e) {

			var $el = $(e.currentTarget),
				$list = $el.next('ul');

			if (this.$list) this.$list.slideToggle();

			if (!this.$list || this.$list[0] != $list[0])
				this.$list = $list.slideToggle();
			else if (this.$list)
				this.$list = null;

			e.preventDefault();

		},

		onFilterClick: function (e) {

			var $target = $(e.currentTarget),
				$current = this.element.find('[data-filter].selected').removeClass('selected');

			if ($target[0] == $current[0]) {
				$.publish('filterSelect', null);
			} else {
				$target.addClass('selected');
				$.publish('filterSelect', $target.data('filter'));
			}

		}

	});

});
